export interface IParsedHref {
  pathname: string
  search: Record<string, string> | undefined
}

/**
 * Splits an internal href into a TanStack Router `to` path and `search` object
 * so `?tab=` deep links survive client-side navigation.
 */
export const parseInternalHref = (href: string): IParsedHref => {
  const queryIndex = href.indexOf('?')
  if (queryIndex === -1) return { pathname: href, search: undefined }

  const pathname = href.slice(0, queryIndex)
  const params = new URLSearchParams(href.slice(queryIndex + 1))
  const search: Record<string, string> = {}

  for (const [key, value] of params.entries()) search[key] = value

  return { pathname, search: Object.keys(search).length > 0 ? search : undefined }
}
